import { Axios } from 'utils/AxiosConfig'

export const getProvince = async (payload) => {
  const { data: response } = await Axios.get(`public/province`, payload)
  return response
}

export const getCity = async (provinceId) => {
  const { data: response } = await Axios.get(`city/${provinceId}`)
  return response
}

export const getDistrict = async (cityId) => {
  const { data: response } = await Axios.get(`district/${cityId}`)
  return response
}

export const getSpecialization = async (payload) => {
  const { data: response } = await Axios.get(`public/specialization`, payload)
  return response
}
export const getEventList = async (payload) => {
  const { data: response } = await Axios.get(`/public/event`, payload)
  return response
}
export const getUserPackageListByRole = async (role) => {
  const { data: response } = await Axios.get(`member/package-subscription/paid-package/${role}`)
  return response
}
export const postImage = async (formData) => {
  const { data: response } = await Axios.post('upload-file', formData, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
  return response
}

export const putConfirmFreeAccount = async (payload) => {
  const { data: response } = await Axios.put(`member/confirm-free-account`, payload)
  return response
}

export const changeProfileImage = async (params) => {
  const { data: response } = await Axios.put(`member/profile/account-information/photo`, params)
  return response
}

export const postPublicFile = async (formData) => {
  const { data: response } = await Axios.post('upload-public-file', formData, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
  return response
}
